// extracted by mini-css-extract-plugin
export default {"title":"styles_title__1gxvb","qrButton":"styles_qrButton__WLL0V","panel":"styles_panel__-kzOQ"};